import { actionTypes } from '../constants';

const createInitialState = () => ({ activeIndex: undefined });

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.createReset:
    case actionTypes.newConfigPageReset:
    case actionTypes.changeDesksSettingsPageReset: {
      return createInitialState();
    }

    case actionTypes.activeDeskIndexChanged: {
      return state.activeIndex === payload
        ? state
        : { ...state, activeIndex: payload };
    }

    default:
      return state;
  }
};
